// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Store_modal__wSppn {
    left: 50%;
    bottom: 5%;
    position: fixed;
    z-index: 1300;
    transition: transform 0.3s cubic-bezier(.4,0,.2,1);
    transform: translate(-50%, 200%);
}

.Store_modalOpen__JsHwF {
    transform: translate(-50%, 0);
}

.Store_modalPay__TxNf3 {
    position: fixed;
    left: 50%;
    bottom: 5%;
    z-index: 1301;
    transform: translate(-50%, 0);
    width: 85%;
    display: flex;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/scenes/Store.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,aAAa;IACb,kDAAkD;IAClD,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,aAAa;IACb,6BAA6B;IAC7B,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".modal {\n    left: 50%;\n    bottom: 5%;\n    position: fixed;\n    z-index: 1300;\n    transition: transform 0.3s cubic-bezier(.4,0,.2,1);\n    transform: translate(-50%, 200%);\n}\n\n.modalOpen {\n    transform: translate(-50%, 0);\n}\n\n.modalPay {\n    position: fixed;\n    left: 50%;\n    bottom: 5%;\n    z-index: 1301;\n    transform: translate(-50%, 0);\n    width: 85%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Store_modal__wSppn`,
	"modalOpen": `Store_modalOpen__JsHwF`,
	"modalPay": `Store_modalPay__TxNf3`
};
export default ___CSS_LOADER_EXPORT___;
